export const BOOST_INTRO_TOOLTIP = 'boost.intro.tooltip';
export const BOOST_TOOLTIP_OPT_IN_BTN = 'boost.tooltip.opt.in.btn';
export const BOOST_TOOLTIP_OPT_OUT_BTN = 'boost.tooltip.opt.out.btn';
export const BOOST_AUDIO_INTRO_PLAYER_TITLE = 'boost.audio.intro.player.title';
export const BOOST_AUDIO_OUTRO_PLAYER_TITLE = 'boost.audio.outro.player.title';
